import { render, staticRenderFns } from "./BookmarkMobile.vue?vue&type=template&id=2e1a3059&"
import script from "./BookmarkMobile.vue?vue&type=script&lang=ts&"
export * from "./BookmarkMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports